export default "__VITE_ASSET__c35d95e5__"